/**
 * ProductAuditListPresenter
 * --
 */
import React, { useState } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  Table,
  Statistic,
  ModalLayout,
  Descriptions,
} from 'components';
import { Avatar, Button, DatePicker, Input, Radio, Select, Tag } from 'antd';
import {
  CheckCircleOutlined,
  EditOutlined,
  PictureOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import { stringToMoneyFormat } from 'utils';

const ProductAuditListPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [isOpened, setIsOpened] = useState(false);

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const formItem = [
    {
      label: '검색어',
      direction: 'column',
      form: [
        {
          input: (
            <>
              <Select
                size="large"
                value={'메뉴명'}
                options={[
                  { label: '메뉴명', value: '메뉴명' },
                  { label: '회원명', value: '회원명' },
                  { label: '전화번호', value: '전화번호' },
                ]}
                style={{ ...styles.form.input.large }}
              />
              <Input
                size="large"
                placeholder="검색어를 입력해주세요"
                style={{ ...styles.form.input.large, width: 350 }}
              />
              <Button size="large" icon={<PlusOutlined />} />
            </>
          ),
        },
      ],
    },
    {
      label: '메뉴 구분',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'전체'}>
                <Radio value={'전체'}>전체</Radio>
                <Radio value={'기본메뉴'}>기본메뉴</Radio>
                <Radio value={'세트메뉴'}>세트메뉴</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '카테고리 분류',
      form: [
        {
          input: (
            <>
              <Select
                size="large"
                options={[
                  { label: '대분류1', value: '대분류1' },
                  { label: '대분류2', value: '대분류2' },
                  { label: '대분류3', value: '대분류3' },
                ]}
                style={{ ...styles.form.input.large }}
                placeholder={'대분류 선택'}
              />
              <Select
                size="large"
                options={[
                  { label: '중분류1', value: '중분류1' },
                  { label: '중분류2', value: '중분류2' },
                  { label: '중분류3', value: '중분류3' },
                ]}
                style={{ ...styles.form.input.large }}
                placeholder={'중분류 선택'}
              />
              <Select
                size="large"
                options={[
                  { label: '소분류1', value: '소분류1' },
                  { label: '소분류2', value: '소분류2' },
                  { label: '소분류3', value: '소분류3' },
                ]}
                style={{ ...styles.form.input.large }}
                placeholder={'소분류 선택'}
              />
              <Select
                size="large"
                options={[
                  { label: '상세분류1', value: '상세분류1' },
                  { label: '상세분류2', value: '상세분류2' },
                  { label: '상세분류3', value: '상세분류3' },
                ]}
                style={{ ...styles.form.input.large }}
                placeholder={'상세분류 선택'}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '메뉴 등록일',
      form: [
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              3개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              전체
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '진열 상태',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'전체'}>
                <Radio value={'전체'}>전체</Radio>
                <Radio value={'진열함'}>진열함</Radio>
                <Radio value={'진열안함'}>진열안함</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '판매 상태',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'전체'}>
                <Radio value={'전체'}>전체</Radio>
                <Radio value={'판매함'}>판매함</Radio>
                <Radio value={'판매안함'}>판매안함</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
  ];

  // NOTE: 테이블 가짜 데이터
  let newData = [];
  // for (let i = 0; i < 3; i++) {
  //   newData.push({
  //     no: i + 1,
  //     카테고리: '커피',
  //     메뉴코드: `0000000`,
  //     img: <Avatar size={32} shape="square" icon={<PictureOutlined />} />,
  //     name: (
  //       <p style={{ display: 'flex', alignItems: 'center' }}>
  //         <Tag
  //           // color={i === 0 ? '#37383C' : i === 1 ? '#58CF04' : '#EAA300'}
  //           style={{
  //             background: 'none',
  //             color: i === 0 ? '#37383C' : i === 1 ? '#58CF04' : '#EAA300',
  //             borderColor:
  //               i === 0 ? '#37383C' : i === 1 ? '#58CF04' : '#EAA300',
  //             width: 48,
  //             fontSize: 8,
  //             fontWeight: 600,
  //             display: 'flex',
  //             justifyContent: 'center',
  //             alignItems: 'center',
  //           }}
  //         >
  //           {i === 0 ? '심사대기' : i === 1 ? '판매중' : '반려'}
  //         </Tag>
  //         죠리퐁 카페라테
  //       </p>
  //     ),
  //     price: 20000,
  //     sale: 18000,
  //     수량: 57400,
  //     심사상태: (
  //       <Select
  //         value={i}
  //         options={[
  //           { label: '심사대기', value: 0 },
  //           { label: '판매중', value: 1 },
  //           { label: '반려', value: 2 },
  //         ]}
  //         style={{ ...styles.form.input.medium }}
  //       />
  //     ),
  //     심사평: (
  //       <Button
  //         type={i === 0 ? 'default' : 'primary'}
  //         icon={i === 0 ? <EditOutlined /> : <CheckCircleOutlined />}
  //         onClick={() => setIsOpened(!isOpened)}
  //       >
  //         확인
  //       </Button>
  //     ),
  //   });
  // }

  const descriptionsItems = [
    {
      key: `1`,
      label: '메뉴명',
      children: '죠리퐁 카페라테',
    },
    {
      key: `2`,
      label: '판매가(수량)',
      children: '20,000원(52,000개)',
    },
    {
      key: `3`,
      label: '판매처',
      children: (
        <button
          style={{
            border: 'none',
            background: 'none',
            textDecoration: 'underline',
            color: '#1C6BFF',
            cursor: 'pointer',
          }}
        >
          주식회사 컴포즈커피
        </button>
      ),
    },
    {
      key: `4`,
      label: '카테고리',
      children: '커피',
    },
    {
      key: `5`,
      label: '내용',
      children: <div style={{ height: 430 }}>에디터!!!!</div>,
    },
  ];

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
        <Row>
          <Col x={24}>
            <Title style={{ ...styles.title }}>메뉴 목록</Title>

            {/* 요약 */}
            <Content
              maxWidth={'100%'}
              padding={0}
              backgroundColor={'none'}
              style={{ marginBottom: 40, display: 'flex' }}
            >
              {[
                { title: '전체', value: 0 },
                { title: '판매함', value: 0 },
                { title: '판매 안함', value: 0 },
                { title: '진열함', value: 0 },
                { title: '진열 안함', value: 0 },
              ].map((_item, _index) => (
                <div
                  key={`${_item.label}-${_index}`}
                  style={{
                    background: '#FFFFFF',
                    borderRadius: 4,
                    width: `calc(100% / 5)`,
                    marginRight: _index === 4 ? 0 : 4,
                    padding: 20,
                  }}
                >
                  <Statistic
                    title={_item.title}
                    value={_item.value}
                    suffix={'건'}
                    direction={'row'}
                    style={{ justifyContent: 'center' }}
                  />
                </div>
              ))}
            </Content>
            {/* 요약 끝 */}

            {/* 검색필터 */}
            <Content
              maxWidth={'100%'}
              padding={0}
              backgroundColor={'none'}
              style={{ marginBottom: 40 }}
            >
              <ExpandableContainer borderRadius={4} padding={20}>
                {formItem.map((_item, _index) => (
                  <div
                    key={`form_${_index}`}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '10px 0px',
                    }}
                  >
                    <div style={{ width: 120, fontSize: 13, fontWeight: 400 }}>
                      <label>{_item.label}</label>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {_item.form.map((_subitem, _subkey) => (
                        <React.Fragment key={`input_${_subkey}`}>
                          {_subitem.input}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                ))}
              </ExpandableContainer>

              {/* 검색/초기화 버튼 */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  marginTop: 48,
                }}
              >
                <Button
                  size="large"
                  type="primary"
                  style={{
                    ...styles.button,
                    background: 'var(--primary-color)',
                  }}
                >
                  검색
                </Button>
                <Button size="large" style={{ ...styles.button }}>
                  초기화
                </Button>
              </div>
              {/* 검색/초기화 버튼 끝 */}
            </Content>
            {/* 검색필터 끝 */}

            {/* 검색결과 */}
            <Content
              maxWidth={'100%'}
              borderRadius={4}
              padding={20}
              style={{ minHeight: 530 }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 20,
                  justifyContent: 'space-between',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <h4
                    style={{ fontSize: 14, fontWeight: 500, marginRight: 20 }}
                  >
                    총 <span>0</span>건
                  </h4>
                  <Button size="large" style={{ marginRight: 8 }}>
                    진열함
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    진열안함
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    판매함
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    판매안함
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    복사
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    삭제
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    분류수정
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    메인진열수정
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    엑셀다운로드
                  </Button>
                </div>
                <div>
                  <Select
                    size="large"
                    value={'등록일순'}
                    options={[
                      { label: '등록일순', value: '등록일순' },
                      { label: '등록일순2', value: '등록일순2' },
                    ]}
                  />
                </div>
              </div>
              <Table
                data={newData}
                isChecked
                columns={[
                  {
                    title: 'No',
                    key: 'no',
                    width: 10,
                  },
                  {
                    title: '카테고리',
                    key: '카테고리',
                  },
                  {
                    title: '메뉴코드',
                    key: '메뉴코드',
                  },
                  {
                    title: '이미지',
                    key: 'img',
                  },
                  {
                    title: '메뉴명',
                    key: 'name',
                    width: 300,
                  },
                  {
                    title: '판매가',
                    key: 'price',
                    render: (item) => stringToMoneyFormat(item),
                  },
                  {
                    title: '할인가',
                    key: 'sale',
                    render: (item) => stringToMoneyFormat(item),
                  },
                  {
                    title: '수량',
                    key: '수량',
                    render: (item) => stringToMoneyFormat(item),
                  },
                  {
                    title: '심사상태',
                    key: '심사상태',
                  },
                  {
                    title: '심사평',
                    key: '심사평',
                  },
                ]}
              />
            </Content>
            {/* 검색결과 끝 */}
          </Col>
        </Row>
      </Content>

      {/* 모달 */}
      <ModalLayout
        type={'modal'}
        open={isOpened}
        onCancel={setIsOpened}
        centered
        closable
        title={'심사평 등록'}
        width={884}
        footer={
          <Content maxWidth={'100%'} padding={0}>
            <Row>
              <Col x={24}>
                <Button>확인</Button>
              </Col>
            </Row>
          </Content>
        }
      >
        <Content
          maxWidth={'100%'}
          padding={'20px 0'}
          style={{
            borderTop: '1px solid #F4F4F5',
            borderBottom: '1px solid #F4F4F5',
          }}
        >
          <Row>
            <Col x={24}>
              <Descriptions items={descriptionsItems} />
            </Col>
          </Row>
        </Content>
      </ModalLayout>
    </>
  );
};

export default ProductAuditListPresenter;
